<template>
  <v-container fluid pa-0 ma-0>
    <v-container fluid pa-0 ma-0 class="test_purple header-background">
      <v-row no-gutters align="start">
        <div class="header">
          <MenuHeaderPublic />
        </div>
      </v-row>
    </v-container>
    <main class="pt-16">
      <v-container class="test_yellow container-policy mt-2">
        <v-col no-gutters>
          <h2 class="policy-title" v-text="$t('general.termAndCondition')" />
          <p
            class="policy-content mt-10"
            v-text="
              $t('tradeCondition.topTitle1', { FIRMANAVN: companyDetails.name })
            "
          />
          <p
            class="policy-content"
            style="margin-top: -10px"
            v-text="$t('tradeCondition.topTitle2')"
          />
          <h6
            class="policy-sub-title"
            v-text="$t('tradeCondition.section1.title')"
          />
          <p
            class="policy-content"
            v-text="
              $t('tradeCondition.section1.content', {
                FIRMANAVN: companyDetails.name,
              })
            "
          />
          <h6
            class="policy-sub-title"
            v-text="$t('tradeCondition.section2.title')"
          />
          <p
            class="policy-content"
            v-text="
              $t('tradeCondition.section2.content', {
                FIRMANAVN: companyDetails.name,
              })
            "
          />
          <h6
            class="policy-sub-title"
            v-text="$t('tradeCondition.section3.title')"
          />
          <p
            class="policy-content"
            v-text="$t('tradeCondition.section3.content')"
          />
          <p
            class="policy-content"
            v-text="$t('tradeCondition.section3.content2')"
          />
          <h6
            class="policy-sub-title"
            v-text="$t('tradeCondition.section4.title')"
          />
          <p
            class="policy-content"
            v-text="$t('tradeCondition.section4.content')"
          />
          <h6
            class="policy-sub-title"
            v-text="$t('tradeCondition.section5.title')"
          />
          <p
            class="policy-content"
            v-text="$t('tradeCondition.section5.content')"
          />
          <p
            class="policy-content"
            v-text="$t('tradeCondition.section5.content2')"
          />
          <h6
            class="policy-sub-title"
            v-text="$t('tradeCondition.section6.title')"
          />
          <h6
            class="policy-sub-title"
            v-text="$t('tradeCondition.section7.title')"
          />
          <p
            class="policy-content"
            v-text="$t('tradeCondition.section7.content')"
          />
          <h6
            class="policy-sub-title"
            v-text="$t('tradeCondition.section8.title')"
          />
          <p
            class="policy-content"
            v-text="$t('tradeCondition.section8.content')"
          />
          <h6
            class="policy-sub-title"
            v-text="$t('tradeCondition.section9.title')"
          />
          <p
            class="policy-content"
            v-text="$t('tradeCondition.section9.content')"
          />
          <p
            class="policy-content"
            v-text="$t('tradeCondition.section9.intro.line1')"
          />
          <p
            class="policy-content"
            v-text="$t('tradeCondition.section9.intro.line2')"
          />
          <p
            class="policy-content"
            v-text="$t('tradeCondition.section9.intro.line3')"
          />
          <p
            class="policy-content"
            v-text="$t('tradeCondition.section9.intro.line4')"
          />
          <p
            class="policy-content"
            v-text="$t('tradeCondition.section9.intro.line5')"
          />
          <p
            class="policy-content"
            v-text="
              $t('tradeCondition.section9.content2', {
                FIRMANAVN: companyDetails.name,
              })
            "
          />
          <h6
            class="policy-sub-title"
            v-text="$t('tradeCondition.section10.title')"
          />
          <p
            class="policy-content"
            v-text="$t('tradeCondition.section10.content')"
          />
          <p
            class="policy-content"
            v-text="$t('tradeCondition.section10.intro.line1')"
          />
          <p
            class="policy-content"
            v-text="$t('tradeCondition.section10.intro.line2')"
          />
          <p
            class="policy-content"
            v-text="$t('tradeCondition.section10.intro.line3')"
          />
          <p
            class="policy-content"
            v-text="$t('tradeCondition.section10.content2')"
          />
          <p
            class="policy-content"
            v-text="$t('tradeCondition.section10.content3')"
          />
          <p
            class="policy-content"
            v-text="
              $t('tradeCondition.section10.content4', {
                MAILADRESSE: companyDetails.email,
              })
            "
          />
        </v-col>
      </v-container>
    </main>
  </v-container>
</template>

<script>
export default {
  name: "TradeCondition",
  data: () => ({
    companyDetails: null,
  }),
  created() {
    this.fetchCompanyData().then();
  },
  methods: {
    async fetchCompanyData() {
      try {
        const response = await axios.get("/app/companyDetails");
        this.companyDetails = response.data.data;
      } catch (error) {
        console.error("Error fetching company data:", error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.policy-title {
  font-size: 2rem !important;
}
.policy-sub-title {
  font-size: 1.3rem !important;
  font-weight: bold;
}
.policy-content {
  font-size: 1.1rem !important;
}
.container-policy {
  max-width: 1400px !important;
  margin: 0 auto;
}

@media screen and (max-width: 960px) {
  .container-policy {
    max-width: none;
    padding: 0 15px !important;
  }
}
@media only screen and (min-width: 960px) and (max-width: 1400px) {
  .container-policy {
    padding: 0 30px !important;
  }
}
</style>
